var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1792 1792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1792 896q0 26-19 45l-256 256q-19 19-45 19t-45-19t-19-45v-128h-384v384h128q26 0 45 19t19 45t-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45t45-19h128v-384H384v128q0 26-19 45t-45 19t-45-19L19 941Q0 922 0 896t19-45l256-256q19-19 45-19t45 19t19 45v128h384V384H640q-26 0-45-19t-19-45t19-45L851 19q19-19 45-19t45 19l256 256q19 19 19 45t-19 45t-45 19h-128v384h384V640q0-26 19-45t45-19t45 19l256 256q19 19 19 45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsMove);
export default __webpack_public_path__ + "static/media/arrowsMove.51c3bdb32d2df4088bbd555239ffe90c.svg";
export { ForwardRef as ReactComponent };